import { MobileCommControlAccount } from "../MobileCommControlAccount";
import { MobileCommControlConfigurations } from "../MobileCommControlConfigurations";
import { MobileCommControlCredentialsTable } from "../MobileCommControlCredentialsTable";
import { MobileCommControlGeneral } from "../MobileCommControlGeneral";
import { MobileCommControlManagement } from "../MobileCommControlManagement";
import { MobileCommControlNetwork } from "../MobileCommControlNetwork";
import { MobileCommControlNotificationTable } from "../MobileCommControlNotificationTable";
import { MobileCommControlPacketsTable } from "../MobileCommControlPacketsTable";
import { MobileCommControlSendLoad } from "../MobileCommControlSendLoad";
import { MobileCommControlSendLoadListenerTable } from "../MobileCommControlSendLoadListenerTable";
import { MobileCommControlTrailer } from "../MobileCommControlTrailer";
import { MobileCommSendLoadOptionsTable } from "../MobileCommSendLoadOptionsTable";
import { DataHeader, DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControl extends Layout {
    dataheaderMobileCommControl: DataHeader;
    layoutMobileCommControlAccount: MobileCommControlAccount;
    layoutMobileCommControlConfigurations: MobileCommControlConfigurations;
    layoutMobileCommControlError: Layout;
    layoutMobileCommControlGeneral: MobileCommControlGeneral;
    layoutMobileCommControlManagement: MobileCommControlManagement;
    layoutMobileCommControlNetwork: MobileCommControlNetwork;
    layoutMobileCommControlNotifications: MobileCommControlNotificationTable;
    layoutMobileCommControlPacketsTable: MobileCommControlPacketsTable;
    layoutMobileCommControlParametersTable: Layout;
    layoutMobileCommControlSendLoad: MobileCommControlSendLoad;
    layoutMobileCommControlSendLoadUpdateListenerTable: MobileCommControlSendLoadListenerTable;
    layoutMobileCommControlSendLoadUpdateOptionsTable: MobileCommSendLoadOptionsTable;
    layoutTableContact: MobileCommControlCredentialsTable;
    layoutTrailer: MobileCommControlTrailer;
    sourceContacts: DataSource;
    sourceMCControl: DataSource;
    sourceMCDriverNotification: DataSource;
    sourceMCErrorSchedule: DataSource;
    sourceMCParameter: DataSource;
    sourceMCPnetPackets: DataSource;
    sourceMCScheduledConfig: DataSource;
    sourceMCSendLoadListener: DataSource;
    sourceMCSendLoadOptions: DataSource;
    sourceMCTest: DataSource;
    tabAccount: Tab;
    tabContacts: Tab;
    tabErrors: Tab;
    tabGeneral: Tab;
    tabManagement: Tab;
    tabNetworkConfigurations: Tab;
    tabNotifications: Tab;
    tabPackets: Tab;
    tabParameters: Tab;
    tabSendLoad: Tab;
    tabSendLoadListener: Tab;
    tabSendLoadOptions: Tab;
    tabTrailer: Tab;
    tabsetMobileCommControl: Tabset;
}
